module.exports = __webpack_public_path__ + "img/zhifu.8d95b7a0.png";